<!-- PAGE HEADER -->
<div class="page-header">
  <h2>Employee Voucher Program</h2>
</div>

<!-- ALERT MESSAGE (OUTSIDE HEADER & HERO) -->
<!-- <div class="alert-section">
  <div class="container">
    <div class="alert-box">
      <p>
        <strong>Important Messages or Alerts</strong> to the users. Lorem ipsum dolor sit
        amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt
        ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
        quis nostrud.
      </p>
    </div>
  </div>
</div> -->

<!-- DEVELOPMENT WARNING (do not add to Prod)-->
<section class="alert-section">
  <div class="container">
    <div class="alert-box">
      <strong>WARNING:</strong>
      THIS IS A DEVELOPMENT SITE. DO NOT ENTER LIVE DATA OR AGREEMENTS INTO THIS SITE.
    </div>
  </div>
</section>

<!-- HERO SECTION -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">

      <!-- IMAGE -->
      <div class="hero-image">
        <img src="assets/Vaccine_image.jpg" alt="Vaccination" />
      </div>

      <!-- CONTENT -->
      <div class="hero-content">
        <h1>Protect Your Team—On Their Schedule</h1>

        <p>
          Your account is active, and youʼre just a few steps away from providing your
organization with a simple, convenient way to expand access to immunizations.
Through this portal, you can set up a Walgreens Immunization Voucher Program
that allows employees or participants to receive vaccinations at any Walgreens
pharmacy nationwide.
        </p>

        <p>
          With an easy enrollment process and vouchers that work across thousands of
locations, supporting health and wellness has never been more accessible.
        </p>

        <P><strong>A streamlined way to help keep your organization protected, informed, and
healthy</strong></P>

        <button class="button-primary mr-30 mb-30 mt-30" (click)="voucherSetup()" >
          Setup your Voucher
        </button>
        <button class="button-primary mb-30 mt-30" (click)="viewVoucher()" >
          View your Voucher
        </button>

      </div>

    </div>
  </div>
</section>


<!-- VACCINES SECTION -->
<section class="vaccines">
  <div class="container">
    <h2>Trusted expertise. Nationwide reach. Proven results.</h2>

    <div class="vaccines-grid">

      <div class="card">
        <div class="card-header">
          <img src="assets/seasonal_vaccines_icon.png" alt="">
          <h3>Scale & Access</h3>
        </div>
        <p>
          78% of the U.S. population lives within 5 miles of a Walgreens. With nearly 30% of vaccinations administered outside traditional work hours, people can get vaccinated on their own schedule.
        </p>
      </div>

      <div class="card">
        <div class="card-header">
          <img src="assets/pharmacist_icon.png" alt="">
          <h3>Clinical Expertise</h3>
        </div>
        <p>
          Our 50,000+ immunizers administer more than 20 vaccines, including co-administration. Nearly half of all vaccines were co-administered during the 2024–2025 respiratory season.
        </p>
      </div>

      <div class="card">
        <div class="card-header">
          <img src="assets/covid_icon_2X.png" alt="">
          <h3>Outcomes That Matter</h3>
        </div>
        <p>
          Nearly 80% of the $9 billion spent annually on vaccine-preventable diseases is attributed to unvaccinated individuals. Expanding vaccination programs can significantly reduce these preventable costs.</p>
      </div>

    </div>
  </div>
</section>